import { ColumnDef } from '@tanstack/react-table';
import { useNavigate } from 'react-router-dom';

import Table from '../common/Table';
import TableHeader from '../common/TableHeader';
import { IPaginationTable } from '../common/interfaces/IPaginationTable';

import { IUser } from '@/interfaces/api/IUser';
import { ICollection } from '@/interfaces/api/collection/ICollection';
import { ICollectionUser } from '@/interfaces/api/user/ICollectionUser';
import { IUserWithAction } from '@/interfaces/api/user/IUserWithAction';

const UsersTable = ({
	collectionUser,
	paginationOption,
	columns,
	refetch,
	usernameQuery,
	setUsernameQuery,
	nameQuery,
	setNameQuery,
	users,
	onSelectUser,
}: {
	collectionUser: ICollectionUser;
	paginationOption: IPaginationTable;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	columns: ColumnDef<IUserWithAction, any>[];
	refetch: () => void;
	usernameQuery: string;
	setUsernameQuery: React.Dispatch<React.SetStateAction<string>>;
	nameQuery: string;
	setNameQuery: React.Dispatch<React.SetStateAction<string>>;
	users: number;
	onSelectUser?: (username: string) => void;
}) => {
	const navigate = useNavigate();

	const handleCollectionWithAction = (
		collection: ICollectionUser,
	): ICollection<IUserWithAction> => {
		return {
			...collection,
			data: collection.data.map((item) => ({
				...item,
				action: '',
			})),
		};
	};

	const handleSelectRow = (selectedUser: IUser) => {
		if (onSelectUser) {
			onSelectUser(selectedUser.username); // Use the provided callback if available
		} else {
			navigate(`/user/users/${selectedUser.id}`); // Default behavior
		}
	};

	return (
		<>
			<TableHeader
				title="Users List"
				counts={[
					{
						label: 'Total Users',
						value: users,
						dataTest: 'total-merchants-count',
					},
				]}
				searchConfigs={[
					{
						query: nameQuery,
						setQuery: setNameQuery,
						placeholder: 'Search by name',
						refetch: refetch,
					},
					{
						query: usernameQuery,
						setQuery: setUsernameQuery,
						placeholder: 'Search by username',
						refetch: refetch,
					},
				]}
			/>
			<div className="mx-2 pb-[2rem] bg-grey-0 border-l border-r border-b border-gray-300 rounded-xl">
				<Table<IUserWithAction>
					collection={handleCollectionWithAction(collectionUser)}
					columns={columns}
					paginationSection={paginationOption}
					tableStyles={{
						tableBox: 'w-full border-t overflow-y-auto h-70',
						table: 'w-full',
						tableBody: '',
						tableBodyTr: 'hover:bg-grey-5 cursor-pointer',
					}}
					handleSelectRow={handleSelectRow}
					dataTest="merchants-table"
				/>
			</div>
		</>
	);
};

export default UsersTable;
